import { UAParser } from 'ua-parser-js';
import { Device } from '../types/player';

export default class UserAgent {
  private static instance: UserAgent;
  private parser: UAParser;

  public constructor() {
    this.parser = new UAParser();
  }

  public static getInstance(): UserAgent {
    if (!UserAgent.instance) {
      UserAgent.instance = new UserAgent();
    }
    return UserAgent.instance;
  }

  public getBrowser(): string {
    return this.parser.getBrowser().name || 'Unknown';
  }

  public getBrowserVersion(): string {
    return this.parser.getBrowser().version || 'Unknown';
  }

  public getOS(): string {
    return this.parser.getOS().name || 'Unknown';
  }

  public getOSVersion(): string {
    return this.parser.getOS().version || 'Unknown';
  }

  public getDevice(): string {
    return this.parser.getDevice().model || 'Unknown';
  }

  public getDeviceType(): string {
    return this.parser.getDevice().type || 'Desktop';
  }

  public getDeviceVendor(): string {
    return this.parser.getDevice().vendor || 'Unknown';
  }

  public getUA(): string {
    return this.parser.getUA();
  }

  public getInfo(): Device {
    return {
      browserName: this.getBrowser(),
      browserVersion: this.getBrowserVersion(),
      osName: this.getOS(),
      osVersion: this.getOSVersion(),
      deviceModel: this.getDevice(),
      deviceType: this.getDeviceType(),
      deviceVendor: this.getDeviceVendor(),
    };
  }
}
